import { __awaiter, __generator } from "tslib";
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import SignIn from '../../components/SignIn';
import AuthService from '../../services/AuthService';
/**
 * Renders the sign-in component with API call
 *
 * @param  {string} [className] - the CSS classes
 * @param  {string} [containerClassName] - the CSS classes
 * @param  {(response: unknown) => void} [onSuccess] - onSuccess call function
 * @param  {(to: string) => void} [onLinkHandler] - links onClick handler
 * @param  {string} [inputStyles] - input CSS classes
 * @param  {string} [buttonStyles] - btn CSS classes
 * @param  {string} [labelStyles] - label CSS classes
 * @param  {string} [linkStyles] - link CSS classes
 * @param  {string} [formStyles] - form CSS classes
 * @param  {string} [formGroupStyles] - form group CSS classes
 *
 * @example
 * <SignInContainer
 *  className='a6y-react-auth__sign-in'
 *  onSuccess={(response: unknown) => void}
 *  onLinkHandler={onLinkHandler}
 * />
 */
var SignInContainer = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, containerClassName = _a.containerClassName, onSuccess = _a.onSuccess, _c = _a.onLinkHandler, onLinkHandler = _c === void 0 ? undefined : _c, onResponse = _a.onResponse, _d = _a.inputStyles, inputStyles = _d === void 0 ? '' : _d, _e = _a.buttonStyles, buttonStyles = _e === void 0 ? '' : _e, _f = _a.labelStyles, labelStyles = _f === void 0 ? '' : _f, _g = _a.linkStyles, linkStyles = _g === void 0 ? '' : _g, _h = _a.formStyles, formStyles = _h === void 0 ? '' : _h, _j = _a.formGroupStyles, formGroupStyles = _j === void 0 ? '' : _j, _k = _a.consentsHrefStyle, consentsHrefStyle = _k === void 0 ? '' : _k, _l = _a.consentInputLabelStyle, consentInputLabelStyle = _l === void 0 ? '' : _l, _m = _a.consentInputStyle, consentInputStyle = _m === void 0 ? '' : _m, _o = _a.consentTextStyle, consentTextStyle = _o === void 0 ? '' : _o, _p = _a.consentSpanStyle, consentSpanStyle = _p === void 0 ? '' : _p, _q = _a.consentsStyle, consentsStyle = _q === void 0 ? '' : _q, formLinkStyle = _a.formLinkStyle;
    var _r = useState(undefined), apiError = _r[0], setApiError = _r[1];
    var _s = useState(false), loader = _s[0], setLoader = _s[1];
    function signIn(email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var response, stopExecution, error_1, stopExecution;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoader(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 8]);
                        return [4 /*yield*/, AuthService.signIn(email, password)];
                    case 2:
                        response = _a.sent();
                        stopExecution = false;
                        if (!onResponse) return [3 /*break*/, 4];
                        return [4 /*yield*/, onResponse('email', email, response)];
                    case 3:
                        stopExecution = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (stopExecution) {
                            return [2 /*return*/];
                        }
                        if (response && response.code) {
                            setLoader(false);
                            return [2 /*return*/, setApiError(response.message)];
                        }
                        else {
                            setLoader(false);
                            if (onSuccess)
                                return [2 /*return*/, onSuccess(response)];
                        }
                        return [3 /*break*/, 8];
                    case 5:
                        error_1 = _a.sent();
                        setLoader(false);
                        stopExecution = false;
                        if (!onResponse) return [3 /*break*/, 7];
                        return [4 /*yield*/, onResponse('email', email, error_1)];
                    case 6:
                        stopExecution = _a.sent();
                        _a.label = 7;
                    case 7:
                        if (stopExecution) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, setApiError(error_1.message)];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function socialSignIn(provider, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, stopExecution, error_2, stopExecution;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoader(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 8]);
                        return [4 /*yield*/, AuthService.socialSignIn(provider, data)];
                    case 2:
                        response = _a.sent();
                        stopExecution = false;
                        if (!onResponse) return [3 /*break*/, 4];
                        return [4 /*yield*/, onResponse(provider, '', response)];
                    case 3:
                        stopExecution = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (stopExecution) {
                            return [2 /*return*/];
                        }
                        if (response && response.code) {
                            setLoader(false);
                            return [2 /*return*/, setApiError(response.message)];
                        }
                        else {
                            setLoader(false);
                            if (onSuccess)
                                return [2 /*return*/, onSuccess(response)];
                        }
                        return [3 /*break*/, 8];
                    case 5:
                        error_2 = _a.sent();
                        setLoader(false);
                        stopExecution = false;
                        if (!onResponse) return [3 /*break*/, 7];
                        return [4 /*yield*/, onResponse(provider, '', error_2)];
                    case 6:
                        stopExecution = _a.sent();
                        _a.label = 7;
                    case 7:
                        if (stopExecution) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, setApiError(error_2.message)];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement("div", { className: containerClassName ? containerClassName : 'a6y-react-auth__sign-in-cnt' },
        React.createElement(SignIn, { loader: loader, className: className, onLinkHandler: onLinkHandler, onClick: signIn, onSocialClick: socialSignIn, apiError: apiError, inputStyles: inputStyles, labelStyles: labelStyles, buttonStyles: buttonStyles, linkStyles: linkStyles, formStyles: formStyles, formGroupStyles: formGroupStyles, consentsHrefStyle: consentsHrefStyle, consentInputLabelStyle: consentInputLabelStyle, consentInputStyle: consentInputStyle, consentTextStyle: consentTextStyle, consentSpanStyle: consentSpanStyle, consentsStyle: consentsStyle, formLinkStyle: formLinkStyle })));
};
export default SignInContainer;
//# sourceMappingURL=SignInContainer.js.map